import { setPageContent } from ".";
import { t } from "./locale";
import { Bulma } from "./view/bulma";
import { centeredBox, errorToast } from "./view/components";

/**
 * @param {Response} res
 * @returns {Promise<Response>}
 */
async function onApiError(res) {
	switch (res.status) {
		case 408:
			errorToast("408: Connection to server timed out");
			break;
		case 500:
			errorToast("500: Internal Server Error");
			break;
		default:
			errorToast(`${res.status} ${res.statusText}: ${await res.text()}`);
	}
	return res;
}

function loadConnectionErrorPage() {
	setPageContent(
		centeredBox(
			"small",
			Bulma.label(t.connectionErrorPage.body),
			Bulma.button(
				{
					onClick: () => (window.location.href = "/"),
					styles: ["is-primary"],
				},
				t.connectionErrorPage.tryAgainButton,
			),
		),
	);
}

export { loadConnectionErrorPage, onApiError };
